// Markdown parsing utility
import { marked } from 'marked';

// Configure marked options
marked.setOptions({
  breaks: true, // Convert \n to <br>
  gfm: true, // GitHub Flavored Markdown
});

/**
 * Parses markdown text to HTML
 * @param markdown - The markdown text to parse
 * @returns HTML string
 */
export function parseMarkdown(markdown: string): string {
  if (!markdown) return '';

  // Parse the markdown
  const html = marked.parse(markdown, { async: false }) as string;

  return html;
}

/**
 * Sanitizes HTML to prevent XSS attacks
 * For production, consider using a library like DOMPurify
 */
export function sanitizeHTML(html: string): string {
  // Basic sanitization - in production, use DOMPurify or similar
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
}
